{
  "MaxPartitions": "Seules les {} premières partitions seront vérifiées pour les appareils, veuillez activer « Telephony-Wide Reporting » dans les paramètres Telsys pour vérifier toutes les partitions.",
  "NAME": "ErrorLanguage",
  "Error_Title": "Désolé",
  "Error_SubTitle": "Nous ne trouvons pas la page que vous recherchez.",
  "Error_Message": "La page ou la ressource a peut-être été déplacée, mise à jour ou supprimée. \n \n Ou vous avez peut-être mal saisi l'adresse web. Veuillez vérifier l'adresse et l'orthographe.",
  "Error_PageTitle": "Désolé, nous ne trouvons pas la page que vous recherchez.",
  "Validations_MustBeUnique": "La valeur doit être unique"
}